import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./pages/Admin/Login.vue"),
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("./pages/Admin/Dashboard.vue"),
    },
    // {
    //   path: "/categorii-drepturi",
    //   name: "categorii-drepturi",
    //   component: () =>
    //     import("./pages/Admin/categorii-drepturi/Categorii-drepturi_list.vue"),
    // },
    // {
    //   path: "/drepturi",
    //   name: "drepturi",
    //   component: () => import("./pages/Admin/drepturi/Drepturi_list.vue"),
    // },
    // {
    //   path: "/grupuri-utilizatori",
    //   name: "grupuri-utilizatori",
    //   component: () =>
    //     import("./pages/Admin/grupuri-utilizatori/Grupuri-utilizatori_list.vue"),
    // },
    {
      path: "/utilizatori",
      name: "utilizatori",
      component: () => import("./pages/Admin/utilizatori/Utilizatori_list.vue"),
    },
    {
      path: "/utilizatori_penalizare",
      name: "utilizatori_penalizare",
      component: () => import("./pages/Admin/utilizatori/Utilizatori_penalizare_list.vue"),
    },
    {
      path: "/categorii_produse",
      name: "categorii_produse",
      component: () =>
        import("./pages/Admin/categorii_produse/Categorii_produse_list.vue"),
    },
    {
      path: "/produse",
      name: "produse",
      component: () => import("./pages/Admin/produse/Produse_list.vue"),
    },

    {
      path: "/consimtamant",
      name: "consimtamant",
      component: () => import("./pages/Admin/Consimtamant.vue"),
    },

    {
      path: "/semnatura",
      name: "semnatura",
      component: () => import("./pages/Admin/Semnatura.vue"),
    },

    {
      path: "/masini",
      name: "masini",
      component: () => import("./pages/Admin/masini/Masini_list.vue"),
    },
    {
      path: "/clienti",
      name: "clienti",
      component: () => import("./pages/Admin/clienti/Clienti_list.vue"),
    },
    {
      path: "/rezervari",
      name: "rezervari",
      component: () => import("./pages/Receptie/Rezervari_list.vue"),
    },

    { path: '/dashboard_masini', name: 'Dashboard Masini', component: () => import("./pages/Dashboard_masini.vue") },
    //zona de service
    { path: "/service", name: "Service", component: () => import("./pages/Service/Login/Login.vue"), },
    // { path: "/devize",                    name: "Devize",                   component: () => import("./pages/Service/Devize/Devize_list.vue"),},
    { path: "/fisa_pdf/:fisa", name: "fisa_pdf", component: () => import("./pages/Service/Fisa_pdf.vue"), },
    { path: "/inspectie_finala/:IdDeviz", name: "inspectie_finala", component: () => import("./pages/Service/Inspectie_finala_pdf.vue"), },
    { path: "/deviz_produse_pdf/:IdDeviz", name: "deviz_produse_pdf", component: () => import("./pages/Service/Deviz_produse_pdf.vue"), },
    { path: "/deviz_consimtamant_pdf/:IdDeviz", name: "deviz_consimtamant_pdf", component: () => import("./pages/Service/Deviz_consimtamant_pdf.vue"), },
    { path: "/raport_rar_pdf/start/:start/stop/:stop", name: "raport_rar_pdf", component: () => import("./pages/Receptie/Raport_rar_pdf.vue"), },
    { path: "/deviz_produse/:id", name: "deviz_produse", component: () => import("./pages/Service/Devize/Deviz_produse.vue"), },
    { path: "/programare_produse/:id_programare", name: "programare_produse", component: () => import("./pages/Receptie/Programare_produse.vue"), },
    { path: '/devize_in_lucru', name: 'devize_in_lucru', component: () => import('./pages/Receptie/Devize_in_lucru_list.vue') },
    { path: '/devize_finalizate', name: 'devize_finalizate', component: () => import('./pages/Receptie/Devize_finalizate_list.vue') },
    { path: '/devize_inchise_fara_factura', name: 'devize_inchise_fara_factura', component: () => import('./pages/Receptie/Devize_inchise_fara_factura_list.vue') },
    { path: '/devize_nefacturate', name: 'devize_nefacturate', component: () => import('./pages/Receptie/Devize_nefacturate_list.vue') },
    { path: '/raport_mecanici', name: 'raport_mecanici', component: () => import('./pages/Receptie/Raport_mecanici_list.vue') },
    { path: '/raport_mecanici_vechi', name: 'raport_mecanici_vechi', component: () => import('./pages/Receptie/Raport_mecanici_list_vechi.vue') },
    { path: '/raport_produse', name: 'raport_produse', component: () => import('./pages/Receptie/Raport_produse_list.vue') },
    { path: '/raport_produse_utilizator', name: 'raport_produse_utilizator', component: () => import('./pages/Receptie/Raport_produse_utilizatori_list.vue') },
    { path: '/raport_produse_deviz', name: 'raport_produse_deviz', component: () => import('./pages/Receptie/Raport_produse_deviz_list.vue') },
    { path: '/raport_adaugare_produse_deviz', name: 'raport_adaugare_produse_deviz', component: () => import('./pages/Receptie/Raport_adaugare_produse_deviz_list.vue') },
    { path: '/raport_produse_mecanici', name: 'raport_produse_mecanici', component: () => import('./pages/Service/Rapoarte/Raport_produse_list.vue') },
    { path: '/raport_analiza', name: 'raport_analiza', component: () => import('./pages/Receptie/Raport_analiza.vue') },
    { path: '/raport_grad_ocupare', name: 'raport_grad_ocupare', component: () => import('./pages/Receptie/Raport_grad_ocupare.vue') },
    { path: '/raport_rar', name: 'raport_rar', component: () => import('./pages/Receptie/Raport_rar.vue') },
    { path: '/devize_de_aprobat', name: 'devize_de_aprobat', component: () => import('./pages/Receptie/Devize_de_aprobat_list.vue') },
    { path: "/devize_draft", name: "devize_draft", component: () => import("./pages/Service/Devize/Devize_draft.vue") },
    { path: "/actiuni", name: "actiuni", component: () => import("./pages/Admin/actiuni/Actiuni_list.vue") },
    { path: "/istoric_login", name: "istoric_login", component: () => import("./pages/Admin/istoric_login/Istoric_login_list.vue") },
    { path: "/istoric_programari", name: "istoric_programari", component: () => import("./pages/Admin/istoric_programari/Istoric_programari.vue") },
    { path: "/istoric_sms", name: "istoric_sms", component: () => import("./pages/Admin/log_mesaje/Log_sms.vue") },
    { path: "/istoric_email", name: "istoric_email", component: () => import("./pages/Admin/log_email/Log_email.vue") },
    { path: "/raport_anulari", name: "raport_anulari", component: () => import("./pages/Admin/raport_anulari/Raport_anulari_list.vue") },
    { path: "/raport_hotel_neasociate", name: "raport_hotel_neasociate", component: () => import("./pages/Admin/raport_hotel_neasociate/Raport_hotel_neasociate_list.vue") },
    { path: "/raport_comenzi_neasociate", name: "raport_comenzi_neasociate", component: () => import("./pages/Admin/raport_comenzi_neasociate/Raport_comenzi_neasociate_list.vue") },
    { path: "/raport_devize_penalizate", name: "raport_devize_penalizate", component: () => import("./pages/Receptie/Raport_devize_penalizate.vue") },
    { path: "/raport_anulari_devize", name: "raport_anulari_devize", component: () => import("./pages/Admin/raport_anulari_devize/Raport_anulari_devize_list.vue") },
    { path: "/setari", name: "setari", component: () => import("./pages/Admin/Setari_list.vue") },
    { path: "/setari_sms", name: "setari_sms", component: () => import("./pages/Admin/Setari_sms.vue") },
    { path: "/setari_email", name: "setari_email", component: () => import("./pages/Admin/Setari_email.vue") },
    { path: "/setari_programator", name: "setari_programator", component: () => import("./pages/Admin/Setari_programator.vue") },
    // { path: "/de_mutat",                  name: "de_mutat",                   component: () => import("./pages/De_mutat.vue")},
    { path: '/conditii_garantie', name: 'conditii_garantie', component: () => import("./pages/Admin/conditii_garantie/Conditii_garantie.vue") },

    { path: '/bearer', name: 'bearer', component: () => import('./pages/Bearer.vue') },

    // { path: '/tokens'                   , name: 'tokens'                  , component: () => import( './pages/Admin/tokens/Tokens_list.vue'                                             ) },
    { path: '/change_password/:token', name: 'parola_noua', component: () => import("./pages/Admin/Parola_uitata.vue") },
    { path: '/manageri_flote', name: 'manageri_flote', component: () => import("./pages/Admin/flote/Manageri_flote_list.vue") },
    { path: '/flote', name: 'flote', component: () => import("./pages/Admin/flote/Firme_flote_list.vue") },
    { path: '/centre_productie', name: 'centre_productie', component: () => import("./pages/Admin/centre_productie/Centre_productie_list.vue") },
    { path: '/marci_masini', name: 'marci_masini', component: () => import("./pages/Admin/marci_masini/Marci_masini_list.vue") },
    { path: '/tipuri_masini', name: 'tipuri_masini', component: () => import("./pages/Admin/tipuri_masini/Tipuri_masini_list.vue") },

    { path: '/servicii_programator', name: 'servicii_programator', component: () => import("./pages/Admin/servicii_programator/Servicii_programator_list.vue") },
    { path: '/zile_libere', name: 'zile_libere', component: () => import("./pages/Admin/utilizatori_zile_libere/Utilizatori_zile_libere_list.vue") },
    { path: '/limitare_rezervari', name: 'limitare_rezervari', component: () => import("./pages/Admin/limitare_rezervari/Limitare_rezervari_list.vue") },
    { path: '/blocare_masini', name: 'blocare_masini', component: () => import("./pages/Admin/blocare_masini/Blocare_masini_list.vue") },
    { path: '/adauga_rezervare', name: 'adauga_rezervare_dialog', component: () => import("./pages/Admin/AdaugaProgramare_dialog.vue") },
  ],
});
